import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request/request.service';
import { ClaimEventInterface } from '@app/my-zone/pages/claims/store/entity/claim-event.interface';
import { AppointmentConfirmationModal } from '@app/my-zone/shared/appointment';
import { NewModal } from 'outshared-lib';
import { Observable, of, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class AppointmentsService {

    constructor(
        private request: RequestService,
        private modalService: NewModal,
    ) {}

    public getAppointments(dossier_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer,
            },
        };

        return this.request.post('schade-afspraakkalender/bepalen/afspraken', payload);
    }

    public setAppointment({
                              adres_relatie_id,
                              schadeherstel_gebeurtenis,
                              dossier_volgnummer,
                              netwerk_id,
                              claim_volgnummer,
                              gebeurtenis,
                              schadeherstel_soort_vervangend_vervoer_code,
                          }: {
        adres_relatie_id: number,
        schadeherstel_gebeurtenis: any[],
        dossier_volgnummer: number,
        netwerk_id: string,
        claim_volgnummer: number,
        gebeurtenis: ClaimEventInterface,
        schadeherstel_soort_vervangend_vervoer_code: string,
    }): Observable<any> {
        const payload = {
            afspraak: {
                adres_relatie_id: adres_relatie_id,
                schadeherstel_gebeurtenis: schadeherstel_gebeurtenis,
            },
            dossier: {
                dossier_volgnummer: dossier_volgnummer,
                claim_volgnummer: claim_volgnummer,
            },
            netwerk_id: netwerk_id,
            schadeherstel_gebeurtenis_code: gebeurtenis.schadeherstel_gebeurtenis_code,
            schadeherstel_soort_vervangend_vervoer_code: schadeherstel_soort_vervangend_vervoer_code,
        };

        return this.request.post('schade-afspraakkalender/vastleggen/reservering', payload).pipe(switchMap((result) => {
            if (!result.data.succes) {
                return throwError(result.messages);
            }
            return of(result);
        }));
    }

    public showModal(afspraak): void {
        const modalRef = this.modalService.open(AppointmentConfirmationModal);

        modalRef.componentInstance.model = {
            naam: afspraak.gebeurtenis.name,
            datum: afspraak.gebeurtenis.schadeherstel_gebeurtenis_datum,
            tijdstip: afspraak.gebeurtenis.schadeherstel_gebeurtenis_tijdstip,
        };
    }
}
